import type { ReactNode } from 'react';

export const symbol_sd: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm133-137h127q14 0 27-9.49T440-390v-73q0-14.02-13-23.51-13-9.49-27-9.49H290v-57h100q0 7 5 12t11.67 5h16.66q6.67 0 11.67-4.95t5-11.55V-569q0-14.45-13-24.22-13-9.78-27-9.78H273q-14.02 0-23.51 9.78Q240-583.45 240-569v73q0 14.02 9.49 23.51Q258.98-463 273-463h117v56H290q0-7-4.5-11.5t-11.33-4.5h-17.09q-6.83 0-11.95 4.95Q240-413.1 240-406.5v16.5q0 14.02 9.49 23.51Q258.98-357 273-357Zm262 0h135q20 0 35-15t15-35v-146q0-20-15-35t-35-15H535q-6 0-10.5 4.5T520-588v216q0 6 4.5 10.5T535-357Zm35-50v-146h100v146H570ZM140-220v-520 520Z"
		/>
	</svg>
);
